<template>
  <a-spin :spinning="loading === 'loading'" class="video-template-list">
    <!-- 消除loading的背景色 -->
    <span v-if="loading === 'loading'"></span>
    <a-empty
      v-if="!dataList.length && loading !== 'loading'"
      :style="{
        margin: '32px 30px 0 0',
        flexGrow: 1,
        opacity: loading === 'loading' ? 0 : 1,
        transition: '.3s'
      }"
      :image="defaultImage"
    />
    <template v-if="presetType === 'decal'">
      <div
        v-for="item in dataList"
        :key="item.id"
        class="sticker-item"
        @click="onClickItem(item)"
        v-show="item.is_collect"
      >
        <span
          @click.stop="starClick(item)"
          class="tem_used_icon"
          :class="{ block: item.is_collect }"
          :title="item.is_collect ? '取消收藏' : '收藏'"
          :style="{
            'background-image': item.is_collect
              ? 'url(/preview/icon/icon_collected.png)'
              : 'url(/preview/icon/icon_collect.png)'
          }"
        ></span>
        <img
          v-if="item.attribute_name == '标准'"
          title="标准"
          class="meal-icon"
          src="/preview/icon/user_meal1.png"
          alt="标准"
        />
        <img
          v-else-if="item.attribute_name == '专业'"
          class="meal-icon"
          title="专业"
          src="/preview/icon/user_meal2.png"
          alt="专业"
        />
        <img
          v-else-if="item.attribute_name == '旗舰'"
          class="meal-icon"
          title="旗舰"
          src="/preview/icon/user_meal3.png"
          alt="旗舰"
        />
        <div class="sticker-item__content" :style="stickerStyle(item)" />
      </div>
    </template>
    <template v-else-if="presetType === 'anime'">
      <lottie-preview
        v-show="item.is_collect"
        v-for="item in dataList"
        :item="item"
        :key="item.id"
        :class="lottieType === 2 ? 'effect-sticker-item' : 'sticker-item'"
        :url="item.url"
        :lottieId="item.id"
        :attributeName="item.attribute_name"
        @click.native="onClickItem(item)"
      />
    </template>
  </a-spin>
</template>
<script>
import { Empty } from 'ant-design-vue';
import { mapActions } from 'vuex';
import { encodeURIIfNeeded } from "../../utils";
import LottiePreview from "../material/LottiePreview";
export default {
  props: ['loading', 'dataList', 'presetType', 'lottieType'],
  components: {
    LottiePreview,
  },
  data() {
    return {
      defaultImage: Empty.PRESENTED_IMAGE_SIMPLE,
    }
  },
  methods: {
    ...mapActions([
      'addStickerItem',
      'addLottieItem',
      'delCollect',
      'addCollect'
    ]),
    stickerStyle(item) {
      const url = item.thumbnail;
      return {
        backgroundImage: `url(${encodeURIIfNeeded(url)})`,
      };
    },
    onClickItem(item) {
      if (item.noAccess) {
        this.$store.commit('handleMealDialogVisible', true);
      } else {
        if (this.presetType == 'decal') {
          this.addStickerItem(item)
        } else if (this.presetType == 'anime') {
          this.addLottieItem({ item, type: this.lottieType })
        }
      }
    },
    toggleUploadDialog(val) {
      this.showDialog = val
    },
    // 点击收藏
    async starClick(item) {
      if (item.is_collect) {
        // 取消
        await this.delCollect({ type: 'assembly', id: item.id })
        this.$set(item, 'is_collect', false)
      } else {
        // 收藏
        await this.addCollect({ type: 'assembly', id: item.id })
        this.$set(item, 'is_collect', true)
      }
    },
  }
}
</script>
<style scoped>
.sticker-item:hover .tem_used_icon,
.tem_used_icon.block {
  display: block;
}
.tem_used_icon {
  display: none;
  vertical-align: middle;
  width: 20px;
  height: 20px;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center 0;
  cursor: pointer;
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 1;
}
.empty {
  height: 159px;
  transition: 100ms;
}
.meal-icon {
  width: 20px;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.sticker-item {
  width: 70px;
  height: 70px;
  margin: 11px 11px 0 0;
  position: relative;
  background: #fff
    url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI4IiBoZWlnaHQ9IjgiIHZpZXdCb3g9IjAgMCAyIDIiPjxwYXRoIGQ9Ik0wIDBMMCAxTDIgMUwyIDJMMSAyTDEgMHoiIGZpbGw9InJnYmEoMCwwLDAsLjIpIi8+PC9zdmc+);
  background-size: 12px;
}

.sticker-item__content,
.sticker-item:after {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.sticker-item:after {
  content: "";
  transition: 0.3s;
}

.sticker-item:hover:after {
  box-shadow: inset 0 0 0 2px #007eff;
}

.sticker-item__content {
  background-size: contain;
  background-position: center;
  background-repeat: no-repeat;
}

.effect-sticker-item {
  width: 108px;
  height: 60px;
  margin: 11px 14px 0 0;
  position: relative;
  background: url(https://img001.aivideo8.com/ai_video/U449/2021-07-23/img/1627005227557.jpg)
    no-repeat;
  background-size: cover;
}
</style>